module.exports = __webpack_public_path__ + "static/media/02-1-galeria-05-perisur-mobile@2x.cb6de239.jpg";